export function formatDateTime(datetime, formatType) {
  const dateObj = new Date(datetime);

  if (isNaN(dateObj.getTime())) {
    return "NA";
  }

  // Convert UTC to IST by adding 5 hours 30 minutes
  const istOffset = 5 * 60 + 30; // IST offset in minutes
  const istDate = new Date(dateObj.getTime() + istOffset * 60 * 1000);

  const day = String(istDate.getDate()).padStart(2, "0");
  const month = String(istDate.getMonth() + 1).padStart(2, "0");
  const year = istDate.getFullYear();

  if (formatType === "date") {
    return `${day}/${month}/${year}`;
  }

  let hours = istDate.getHours();
  const minutes = String(istDate.getMinutes()).padStart(2, "0");
  const isPM = hours >= 12;
  const meridian = isPM ? "PM" : "AM";

  hours = hours % 12 || 12;

  const formattedTime = `${hours}:${minutes} ${meridian}`;

  return `${day}/${month}/${year} | ${formattedTime}`;
}

